import { render, staticRenderFns } from "./analysis-demographics.vue?vue&type=template&id=d3272e24&scoped=true&"
import script from "./analysis-demographics.vue?vue&type=script&lang=js&"
export * from "./analysis-demographics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3272e24",
  null
  
)

export default component.exports